<template>
    <td-dialog
        :title="$t(title)"
        :visible.sync="dialogOrgVisible"
        :before-close="orgDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        height="600px"
        width="280px"
        append-to-body
    >
        <td-orgDevtree
            :lazyloading="lazyloading"
            :height="height"
            :draggable="false"
            :isDbClick="isDbClick"
            :isClick="isClick"
            @getCheckedNodes="getCheckedNodes"
            :imgloading="false"
            :deviceTypeList="deviceTypeList"
            ref="TdDialogTree"
            @onDbClickTree="onDbClickTree"
            @onClick="onClick"
            @checkChange="checkChange"
            :checkStrictly="checkStrictly"
            :checkNodes="checkNodes"
            :showBox="true"
        >
        </td-orgDevtree>
        <span slot="footer">
            <td-button type="primary" size="small" @click="submitForm()">{{ $t('common.CONFIRM') }}</td-button>
            <td-button size="small" @click="orgDialogClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
export default {
    props: {
        title: {
            type: [String, String]
        },
        dialogOrgVisible: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        isDbClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        isClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        checkNodes: {
            type: Array,
            default: function() {
                return [];
            }
        },
        height: {
            type: Number,
            default: function() {
                return 400;
            }
        },
        // 是否遵循父节点选中后子节点也相继选中
        checkStrictly: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        lazyloading: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 设备类型
        deviceTypeList: {
            type: Array,
            default: function() {
                return null;
            }
        },
        width: {
            type: Number,
            default: function() {
                return 220;
            }
        }
    },
    mounted() {},
    data() {
        return {
            selectedNodes: []
        };
    },

    methods: {
        // 提交数据
        submitForm(formName) {
            this.selectedNodes = this.$refs.TdDialogTree.getCheckedNodes();
            this.$emit('selected', this.selectedNodes);
            this.orgDialogClose();
        },
        // 关闭窗口之前需要调用的方法
        orgDialogClose() {
            this.$emit('orgDialogClose');
        },
        // 树形节点单击事件
        onClick(data) {
            this.clickData = data;
            if (this.isClick) {
                this.$emit('onClick', data);
            }
        },
        getCheckedNodes() {
            if (this.showBox) {
                let checkedNodes = this.$refs.TdDialogTree.getCheckedNodes();
                return checkedNodes;
            }
            return null;
        },
        onDbClickTree(data) {
            if (this.isDbClick) {
                this.$emit('onDbClickTree', data);
            }
        },
        // 单选框，复选框选中状态修改触发
        checkChange(data, isCheck) {
            this.$emit('checkChange', data, isCheck);
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
